<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="Select Sku" v-model="modal.sku.visible" width="400px"
      append-to-body>
      <el-input v-model="searchQuery" placeholder="Search sku name" @input="handleSearchInput"
        style="margin-bottom: 20px" />
      <div class="chip-container">
        <el-tag v-for="(sku, index) in skuList" :key="index" class="sku-chip" @click="handleSelect(sku)" type="info">
          {{ sku.code }}
        </el-tag>
      </div>
      <template #footer>
        <el-button @click="modal.sku.visible = false">Cancel</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useModalStore } from '@/stores/modal'
import { useShopDataStore } from '@/stores/shopData'

const modal = useModalStore()
const shopDataStore = useShopDataStore()

const searchQuery = ref('')
const skuList = ref([])
const originalSkuList = ref([])

onMounted(() => {
  searchQuery.value = ''
  skuList.value = shopDataStore.defaultSkuList || []
  originalSkuList.value = [...skuList.value]
})

function handleSearchInput() {
  const query = searchQuery.value.trim().toLowerCase()
  if (query) {
    skuList.value = originalSkuList.value.filter(sku => sku.code?.toLowerCase().includes(query))
  } else {
    skuList.value = [...originalSkuList.value]
  }
}

function handleSelect(row) {
  modal.resolveSku(row)
}
</script>

<style scoped>
.chip-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.sku-chip {
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
}

.sku-chip:hover {
  transform: scale(1.05);
}
</style>
